import { render } from "./ServiceTabs.vue?vue&type=template&id=f44d0f9e"
import script from "./ServiceTabs.vue?vue&type=script&lang=js"
export * from "./ServiceTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__